import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import StudioHeadContent from '../StudioHeadContent/StudioHeadContent';
import ScrollAnimation from 'react-animate-on-scroll';
import './StudioHeader.css';

class StudioHeader extends PureComponent {
    render() {
        const { studioCTA } = this.props;

        return (
            <div className="studio-header">
                <div className="main-bg">
                    <section className="hero">
                        <div className="hero-body">
                            <div className="container">
                                <div className="columns">
                                    <div className="column is-offset-1-tablet is-10-tablet">
                                        <div className="title-wrapper">
                                            <h1 className="hidden">Redefining Studios in Los Angeles</h1>
                                            <ScrollAnimation duration={1.0} animateOnce={true} animateIn={'fadeInRight'} initiallyVisible={false}>
                                                <div className="pre-title">STUDIO</div>
                                            </ScrollAnimation>

                                            <ScrollAnimation duration={1.2} delay={300} animateOnce={true} animateIn={'fadeInRight'} initiallyVisible={false}>
                                                <div className="big-title">
                                                    The standard for premium
                                                    <br /> studio facilities and operations 
                                                </div>
                                            </ScrollAnimation>
                                            <ScrollAnimation duration={1.3} delay={400} animateOnce={true} animateIn={'fadeInRight'} initiallyVisible={false}>
                                                <div className="hero-desc">
                                                    Hudson Pacific has been a leading independent studio owner and operator for nearly two decades. Our portfolio of high-quality sound stages and production services delivers reliable, efficient studio environments for today’s leading media companies. 
                                                </div>
                                            </ScrollAnimation>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* Stats */}
                    {studioCTA && <StudioHeadContent studioCTA={studioCTA} />}
                </div>
            </div>
        );
    }
}

StudioHeader.propTypes = {
    studioCTA: PropTypes.array,
};

export default StudioHeader;
